var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupermarketCoffee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Supermarket coffee",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#232323",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 19 L37 19 L34.5 49 A3 3 0 0 1 31.5 51.6 L24.5 51.6 A3 3 0 0 1 21.5 49 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19 L39.5 19 L39.5 14.5 L16.5 14.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 12 L31 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 31 L35.8 31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 39 L57 39 L54.5 51 A2.5 2.5 0 0 1 52 53 L44 53 A2.5 2.5 0 0 1 41.5 51 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5 39 L46 33.5 L52 33.5 L54.5 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 43.5 L45.4 48.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 43.5 L48 48.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 43.5 L50.6 48.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupermarketCoffee);
export default __webpack_public_path__ + "static/media/supermarket-coffee.b92fffbd457107a9bf1c5ce330af7f1a.svg";
export { ForwardRef as ReactComponent };